export default {
    videos: 'Videos',
    data_consumed: 'Dades consumides (mb)',
    size: 'Grandària (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'No hi ha cap fitxer',
    text_upload_file: 'Começar a carregar un nou fitxer',
    upload: 'Carrega',
    quota_label: 'Espai utilitzat',
    quota_of: '{used} de {limit}',
    quota_none: 'El teu pla no inclou espai d\'emmagatzematge: no es poden pujar vídeos. Amplia el pla per poder pujar-los.',
    quota_full: 'Has omplert l\'espai del teu pla. Buida la paperera o amplia el pla per pujar més vídeos.',
    quota_exceeded: 'El vídeo ocupa {size} i només queden {free} lliures al teu pla. Buida la paperera o amplia el pla.',
}